import { Button, Box } from "@material-ui/core";
import React, {  useEffect} from "react";
import { useStyles } from "../styles";
// import { useTranslation } from "react-i18next";
import { LoadingWidget } from "Components/index";
import { useOrganizationConstants } from "Hooks/organization/useOrganizationConstants";
import { useFormContext } from "react-hook-form";
import { useOrganization } from "Hooks/organization/useOrganization";
// import { checkArrayLength, getCompanyId, getUserId } from "src/utils";
// import { useOrganizationValidation } from "Validations/Organization/useOrganizationValidation";
// import { isEmpty } from "lodash";
// import { useRecoilState } from "recoil";
// import { CompanyState } from "Recoil/LoggedInUserDetail/atom";

const Action = ({ activeStep, setActiveStep }) => {
  const classes = useStyles();
  const methods = useFormContext();
  const { organizationFormStepper } = useOrganizationConstants();
  const { apiIntegration } = useOrganization({ methods });
  const { watch, trigger, setValue } = methods;
  const steps = organizationFormStepper;
  const isLastStep = activeStep === steps.length - 1;
  const handleBack = () => setActiveStep(activeStep - 1);
  const { loader } = watch();

  useEffect(() => setValue("companySetting", false), []);

  const handleSubmit = async () => {
    const isValid = await trigger();

    apiIntegration(isValid, activeStep, changeStep);
  };

  const changeStep = () => {
    if (isLastStep) {
      window.location.reload();
    } else {
      setActiveStep(activeStep + 1);
    }
  };
  return (
    // <DialogActions className={classes.dialogActions}>
    <Box display="flex">
      {/* <Button color="primary" onClick={handleClose}>
        {t("text.cancel")}
      </Button> */}
      {activeStep !== 0 ? (
        <Button
          color="primary"
          className="mr15 btn-default"
          style={{ minWidth: "110px" }}
          variant="outlined"
          data-testid="btn"
          onClick={handleBack}
        >
          Previous
        </Button>
      ) : null}
      <div className={classes.wrapper}>
        <Button
          type="button"
          variant="contained"
          color="primary"
          data-testid="btn"
          onClick={handleSubmit}
          disabled={loader}
        >
          {loader ? (
            <LoadingWidget color="white" />
          ) : isLastStep ? (
            "Save"
          ) : (
            "Next"
          )}
        </Button>
      </div>
    </Box>
    // </DialogActions>
  );
};

export default Action;
